<template>
  <u-animate-container id="footer">
    <div class="container">
      <u-animate
        class="left"
        name="fadeIn"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <img src="@/assets/images/logo_bottom.png" alt="西河五金" />
        <div class="desc">{{ $t("footer.left.desc") }}</div>
        <div class="sign">{{ $t("footer.left.sign") }}</div>
      </u-animate>
      <u-animate
        class="info"
        name="fadeInLeft"
        delay="0.3s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div class="title">{{ $t("footer.info.name") }}</div>
        <div class="line"></div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/images/icon_bottom_address.png" />
          </div>
          <span>{{ $t("footer.info.address") }}</span>
        </div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/images/icon_bottom_config.png" />
          </div>
          <span>{{ $t("footer.info.rivet") }}</span>
        </div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/images/icon_bottom_tel1.png" />
          </div>
          <a href="tel:18033246966">18033246966</a>
        </div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/images/icon_bottom_tel2.png" />
          </div>
          <a href="tel:075786602123">0757-86602123</a>
        </div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/images/icon_bottom_email.png" />
          </div>
          <span>sales@sailuk-rivet.com</span>
        </div>
      </u-animate>
      <u-animate
        class="nav"
        name="fadeInLeft"
        delay="0.6s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div class="title">{{ $t("footer.web.title") }}</div>
        <div class="line"></div>
        <router-link to="/index">{{ $t("footer.web.index") }}</router-link>
        <router-link to="/about">{{ $t("footer.web.about") }}</router-link>
        <router-link to="/index">{{ $t("footer.web.quality") }}</router-link>
        <router-link to="/product/0">{{
          $t("footer.web.product")
        }}</router-link>
        <router-link to="/contact">{{ $t("footer.web.contact") }}</router-link>
      </u-animate>
      <u-animate
        class="mobile_nav"
        name="fadeInLeft"
        delay="0.9s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div class="title">{{ $t("footer.mobile.title") }}</div>
        <div class="line"></div>
        <a v-for="(item, index) in linkList" :key="index" :href="item.url">{{
          locale === "zh-cn" ? item.title : item.titleEn
        }}</a>
        <img
          v-if="locale === 'zh-cn'"
          src="@/assets/images/company.png"
          class="code_img"
        />
      </u-animate>
    </div>
    <img src="@/assets/images/footer_img.png" class="footer_img" />
    <u-animate
      class="copyright"
      name="fadeInUp"
      delay="0.9s"
      duration="1s"
      :iteration="1"
      :offset="0"
      animateClass="animated"
      :begin="false"
    >
      西河五金 © 版权所有2018
      <a href="http://www.beian.miit.gov.cn">粤ICP备12071998号</a>
    </u-animate>
  </u-animate-container>
</template>

<script>
import { title } from "process";
import { UAnimateContainer, UAnimate } from "vue-wow";
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  props: {
    locale: {
      type: String,
      default: "zh-cn"
    }
  },
  data() {
    return {
      linkList: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post(
          "/api/link/list",
          {},
          {
            headers: {
              token: "application",
              "Accept-Language": this.locale
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.errorCode === 0) {
            this.linkList = res.data.data;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
#footer {
  width: 100%;
  height: auto;
  overflow: hidden;
  background: #54565a;
  color: #fff;
  padding: 60px 0;
  box-sizing: border-box;
  .container {
    width: 1140px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    .left {
      width: 250px;
      float: left;
      font-size: 0.13rem;
      height: auto;
      overflow: hidden;
      color: #ddd;
      img {
        width: 220px;
        height: auto;
      }
      .desc {
        margin-top: 15px;
        line-height: 1.8;
        word-break: break-all;
        text-align: justify;
      }
      .sign {
        float: right;
        margin-top: 15px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: -30px;
          top: 0;
          bottom: 0;
          margin: auto;
          height: 1px;
          background: #ddd;
          width: 25px;
        }
      }
    }
    .info {
      margin-left: 90px;
      width: 220px;
      float: left;
      .title {
        text-align: left;
        color: #fff;
        height: 40px;
        line-height: 30px;
        font-size: 0.16rem;
      }
      .line {
        width: 100px;
        height: 1px;
        background: #fff;
        margin-bottom: 15px;
      }
      .item {
        height: auto;
        overflow: hidden;
        line-height: 1.5;
        font-size: 0.14rem;
        color: #ddd;
        margin-bottom: 15px;
        display: flex;
        align-items: flex-start;
        .item_img {
          width: 15px;
          height: auto;
          margin-right: 10px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: auto;
            display: flex;
          }
        }
        &:nth-of-type(3) {
          img {
            width: 13px;
          }
        }
        span,
        a {
          float: left;
          width: 185px;
          transition: all 0.35s;
          color: #ddd;
          text-decoration: none;
          font-size: 0.14rem;
        }
      }
    }
    .nav,
    .mobile_nav {
      width: 170px;
      float: left;
      margin-left: 110px;
      .title {
        text-align: left;
        color: #fff;
        height: 40px;
        line-height: 30px;
        font-size: 0.16rem;
      }
      .line {
        width: 100px;
        height: 1px;
        background: #fff;
        margin-bottom: 15px;
      }
      a {
        text-decoration: none;
        transition: all 0.35s;
        color: #ddd;
        font-size: 0.14rem;
        float: left;
        line-height: 1.5;
        margin-bottom: 15px;
        width: 100%;
        &:hover {
          color: #fd8204;
        }
      }
    }
  }
  .copyright {
    text-align: center;
    font-size: 0.13rem;
    color: #fff;
    a {
      color: #fff;
      text-decoration: none;
      transform: all 0.5s;
      &:hover {
        color: #fd8204;
      }
    }
  }
  img.footer_img {
    display: block;
    margin: 30px auto;
    width: 250px;
    height: auto;
  }
  img.code_img {
    width: 100px;
  }
}
@media screen and (max-width: 750px) {
  #footer {
    padding: 30px 0;
    .container {
      width: 100%;
      .left {
        margin: 0px auto 30px;
        display: block;
        float: none;
        width: 300px;
        .desc {
          font-size: 0.7rem;
        }
        .sign {
          font-size: 0.7rem;
          margin-top: 0.5rem;
        }
        img {
          width: 8rem;
          margin-left: auto;
          margin-right: auto;
          display: block;
        }
      }
      .info {
        margin: 0 auto 30px;
        float: none;
        width: 300px;
        .item {
          span {
            font-size: 0.7rem;
            width: 13rem;
          }
          a {
            font-size: 0.7rem;
          }
        }
        .title {
          font-size: 0.8rem;
        }
      }
      .nav {
        margin: 0 auto 30px;
        float: none;
        width: 300px;
        height: auto;
        overflow: hidden;
        display: none;
        a {
          font-size: 0.8rem;
        }
        .title {
          font-size: 0.8rem;
        }
      }
      .mobile_nav {
        display: flex;
        flex-direction: column;
        margin: 0 auto 30px;
        float: none;
        width: 300px;
        height: auto;
        overflow: hidden;
        a {
          font-size: 0.8rem;
          float: left;
          width: 50%;
        }
        .title {
          font-size: 0.8rem;
        }
      }
    }
    img.footer_img {
      width: 80%;
      margin: 0px auto 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Common/Footer.vue